/**
 * Returns today's date as a YYYY-MM-DD string in the user's local timezone.
 * Using new Date().toISOString() would give the UTC date, which breaks midnight
 * boundaries for users in non-UTC timezones.
 */
export function localDateString() {
  const d = new Date()
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
